import React, {memo, useMemo} from 'react';
import {useFormatDate} from '@octavius-rocks/ui';
import {BarChart} from '@octavius-rocks/ui';
import {DateUtils} from '@octavius-rocks/api'

import {
	PAGEVIEWS_AGGREGATION_DAY,
	PAGEVIEWS_AGGREGATION_HOUR,
	PAGEVIEWS_AGGREGATION_MINUTES_5,
	PAGEVIEWS_AGGREGATION_MONTH,
} from '../../data/repository';
import {useErrors} from '../../hook/useErrors';

const CONTINUATION_TIMESTAMPS = {
	[PAGEVIEWS_AGGREGATION_MINUTES_5]: DateUtils.makeContinuos5Minutes,
	[PAGEVIEWS_AGGREGATION_HOUR]: DateUtils.makeContinuosHours,
	[PAGEVIEWS_AGGREGATION_DAY]: DateUtils.makeContinuosDays,
	[PAGEVIEWS_AGGREGATION_MONTH]: DateUtils.makeContinuosMonths,
};

const AGGREGATION_TIME_SHIFT = {
	[PAGEVIEWS_AGGREGATION_DAY]: 12 * 60 * 60 * 1000,
}

const formatDate = useFormatDate();

const PageviewChart = ({
	height = false,
	value = [],
	aggregation = PAGEVIEWS_AGGREGATION_DAY
}) => {

	const errors = useErrors();
	const mappedData = useMemo(()=>{
		const timestamps = CONTINUATION_TIMESTAMPS[aggregation];
		const timeShift = AGGREGATION_TIME_SHIFT?.[aggregation] ?? 0;

		const conData = timestamps(value.map(d=>{
			return {
				...d,
				hits: d.hits,
				timestamp: Date.parse(d.timestamp.replace(" ", "T")) + timeShift,
			}
		}));
		return conData.map(({timestamp, hits})=>{
			return {
				timestamp,
				hits: hits ?? 0,
			}
		});
	}, [JSON.stringify(value)]);

	const style = {};
	if(height){
		style.position = "relative";
		style.height = height;
	}

	return <div style={style}>
		<BarChart
			height={height ? height : 300}
			data={mappedData.map(d => ({date: new Date(d.timestamp), hits: d.hits}))}
			timeUnit={aggregation}
		/>
	</div>
};

export default memo(PageviewChart);
